import { useQuery } from "@tanstack/react-query";
import { getBusinessOwner } from "../actions/getBusinessOwner.aciton";

export const useGetBusinessOwner = () => {
    return useQuery({
        queryKey: ["business-owner"],
        queryFn: getBusinessOwner,
    });
}